export default __webpack_public_path__ + "0248f6d2d5415b1b62d04c57a3de4f9924ab6676/4a3dbbaeebd81c970f39dfd9033ad55f.png";